import { render, staticRenderFns } from "./ProductionFive.vue?vue&type=template&id=edc26508&scoped=true&"
import script from "./ProductionFive.vue?vue&type=script&lang=js&"
export * from "./ProductionFive.vue?vue&type=script&lang=js&"
import style0 from "./ProductionFive.vue?vue&type=style&index=0&id=edc26508&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc26508",
  null
  
)

export default component.exports